export const verifyForm = (
  form: Record<string, string>
): Record<string, string | undefined> => {
  return Object.keys(form).reduce((finalObject, value) => {
    const hasError = !/^[a-zA-Z0-9_.-]*$/.test(form[value]);
    let errorMessage = hasError
      ? 'The field allows letters, numbers or special characters: - . _'
      : undefined;

    if (value === 'accountIdentifier' && !errorMessage) {
      const splitField = form[value].split('.');
      const wrongPattern =
        splitField.length !== 2 ||
        splitField.some((field) => field.length === 0);
      errorMessage = wrongPattern
        ? 'The account name must have the pattern: org_name.account_name'
        : undefined;
    }

    finalObject[value] = errorMessage;
    return finalObject;
  }, {});
};
